import axios from '@/api/config';

const questionType = {
  getQuestionTypeById(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/getQuestionType/` + data, {});
  },
  getQuestionType(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/getQuestionType`, {params: data});
   },
  getQuestionTypeList(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/getQuestionTypeList`, {params: data});
  },
  getQuestionTypeTree(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/getQuestionTypeTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/questionType/pageList`, data);
  },
  addQuestionType(data) {
    return axios.post(`${process.env.BASE_URL}/questionType/addQuestionType`, data);
  },
  updateQuestionType(data) {
    return axios.put(`${process.env.BASE_URL}/questionType/updateQuestionType`, data);
  },
  deleteQuestionType(data) {
    return axios.delete(`${process.env.BASE_URL}/questionType/deleteQuestionType`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/questionType/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/questionType/importData`, data);
  }
}

export default questionType;



// WEBPACK FOOTER //
// ./src/api/questionType.js